'use server'

import type { ProfiloCodice } from './formaCodice'
import { getOpzioniModello, getProfiloCodice, type ModelloOption } from './queries'

const slugValido = (marcaSlug: unknown): marcaSlug is string =>
  typeof marcaSlug === 'string' && /^[a-z0-9-]{1,80}$/.test(marcaSlug)

/** The model select of the paint search, loaded once the brand is chosen. */
export async function modelliDellaMarca(marcaSlug: unknown): Promise<ModelloOption[]> {
  if (!slugValido(marcaSlug)) return []
  return getOpzioniModello(marcaSlug)
}

/** The brand's usual code shape (example and warning under "Codice colore"). */
export async function profiloCodiceDellaMarca(marcaSlug: unknown): Promise<ProfiloCodice | null> {
  if (!slugValido(marcaSlug)) return null
  return getProfiloCodice(marcaSlug)
}
